import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/arrow_down.png';
import _imports_1 from '@/assets/img/first.png';
import _imports_2 from '@/assets/img/second.png';
import _imports_3 from '@/assets/img/third.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-712fdcba"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "aggregate-daily-sales-report"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "num"
};
var _hoisted_4 = {
  class: "desc"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title mt-2 flex align-center justify-between"
  }, " 各小时进料情况 ", -1);
});
var _hoisted_6 = {
  class: "box"
};
var _hoisted_7 = {
  class: "feedingTabs"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "各供应商对比", -1);
});
var _hoisted_11 = {
  class: "box"
};
var _hoisted_12 = {
  class: "tab"
};
var _hoisted_13 = ["onClick"];
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title mt-2"
  }, "进料趋势", -1);
});
var _hoisted_15 = {
  class: "box"
};
var _hoisted_16 = {
  key: 2,
  class: "box mt-2"
};
var _hoisted_17 = {
  class: "title mt-2 flex align-center justify-between"
};
var _hoisted_18 = {
  class: "text"
};
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "arrow_down"
  }, null, -1);
});
var _hoisted_20 = {
  key: 3,
  class: "rankList"
};
var _hoisted_21 = {
  key: 0,
  class: "logo",
  src: _imports_1
};
var _hoisted_22 = {
  key: 1,
  class: "logo",
  src: _imports_2
};
var _hoisted_23 = {
  key: 2,
  class: "logo",
  src: _imports_3
};
var _hoisted_24 = {
  key: 3,
  class: "num"
};
var _hoisted_25 = {
  class: "info"
};
var _hoisted_26 = {
  class: "weight"
};
var _hoisted_27 = {
  key: 4,
  class: "box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_type_tab = _resolveComponent("c-type-tab");
  var _component_c_date_header_with_btn = _resolveComponent("c-date-header-with-btn");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_bar_echart_mul = _resolveComponent("bar-echart-mul");
  var _component_c_no_data = _resolveComponent("c-no-data");
  var _component_pie_echart = _resolveComponent("pie-echart");
  var _component_c_nothing = _resolveComponent("c-nothing");
  var _component_van_picker = _resolveComponent("van-picker");
  var _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_c_type_tab, {
    onConfirmType: _ctx.confirmType
  }, null, 8, ["onConfirmType"]), _createVNode(_component_c_date_header_with_btn, {
    ref: "dateRef",
    type: _ctx.params.type,
    onConfirmDate: _ctx.confrimDate,
    onSwitch: _ctx.switchClick
  }, null, 8, ["type", "onConfirmDate", "onSwitch"]), _createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 2
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryData, function (item, index) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: index,
          onClick: _ctx.toReportDetail
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))];
    }),
    _: 1
  }), _ctx.params.type === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedingTabs, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["feedingTab", {
        active: _ctx.feedingTabActive === index
      }]),
      key: item,
      onClick: function onClick($event) {
        return _ctx.feedingTabClick(index);
      }
    }, [_createElementVNode("span", null, _toDisplayString(item), 1), _hoisted_9], 10, _hoisted_8);
  }), 128))]), _ctx.dayData.lineData.flatMap(function (item) {
    return item;
  }).length ? (_openBlock(), _createBlock(_component_bar_echart_mul, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.dayData)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))])], 64)) : _createCommentVNode("", true), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: _normalizeClass([{
        tabActive: item === _ctx.curTab,
        tabActiveLeft: item === '进料量' && item === _ctx.curTab,
        tabActiveRight: item === '金额' && item === _ctx.curTab
      }, "tabItem"]),
      onClick: function onClick($event) {
        return _ctx.tabClick(item);
      }
    }, _toDisplayString(item), 11, _hoisted_13);
  }), 128))]), _createVNode(_component_pie_echart, _normalizeProps(_guardReactiveProps(_ctx.categoryGoodsCount)), null, 16)]), _ctx.params.type !== 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_ctx.dayDataTrend.lineData.flatMap(function (item) {
    return item;
  }).length ? (_openBlock(), _createBlock(_component_bar_echart_mul, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.dayDataTrend)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))])], 64)) : _createCommentVNode("", true), _ctx.params.type === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_ctx.dayDataTrend1.lineData.flatMap(function (item) {
    return item;
  }).length ? (_openBlock(), _createBlock(_component_bar_echart_mul, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.dayDataTrend1)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [_createTextVNode(" 各供应商排行榜 "), _ctx.columns.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "supplierSelect flex align-center justify-between",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.openPopup && _ctx.openPopup.apply(_ctx, arguments);
    })
  }, [_createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.supplier.text), 1), _hoisted_19])) : _createCommentVNode("", true)]), _ctx.supplierContrastData.length ? (_openBlock(), _createElementBlock("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supplierContrastData, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "rankListItem flex align-center"
    }, [index === 0 ? (_openBlock(), _createElementBlock("img", _hoisted_21)) : _createCommentVNode("", true), index === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_22)) : _createCommentVNode("", true), index === 2 ? (_openBlock(), _createElementBlock("img", _hoisted_23)) : _createCommentVNode("", true), index > 2 ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(index + 1), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_25, _toDisplayString(item.plate_number), 1), _createElementVNode("span", _hoisted_26, _toDisplayString(item.net_weight) + "吨", 1)]);
  }), 128))])) : _createCommentVNode("", true), !_ctx.supplierContrastData.length ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_c_nothing)])) : _createCommentVNode("", true)]), _createVNode(_component_van_popup, {
    show: _ctx.show,
    "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.show = $event;
    }),
    position: "bottom"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_picker, {
        title: "选择供应商",
        columns: _ctx.columns,
        round: "",
        onConfirm: _ctx.onConfirm,
        onCancel: _ctx.onCancel
      }, null, 8, ["columns", "onConfirm", "onCancel"])];
    }),
    _: 1
  }, 8, ["show"])]);
}